<template>
  <div class="disclaimer-page">
    <div class="container custom-padding">
      <button
        type="button"
        class="btn btn-primary back-button mb-2"
        @click="goBack"
      >
        <i class="icon dripicons-chevron-left"></i> Return
      </button>
      <div class="disclaimer-header mb-4">
        <h1 id="disclaimerTitle" v-if="currentLang === 'zh-TW'">
          免責聲明及AI生成內容著作權聲明
        </h1>
        <h1 id="disclaimerTitle" v-else>
          Disclaimer and Copyright Notice for AI Generated Content
        </h1>
        <!-- <button
          type="button"
          class="btn btn-primary back-button"
          @click="goBack"
        >
          <i class="icon dripicons-chevron-left"></i> Return
        </button> -->
      </div>

      <div class="disclaimer-content">
        <div class="zh-content" v-if="currentLang === 'zh-TW'">
          <p>
            本網站的部分內容和功能由生成式人工智慧（Generative
            AI）技術自動生成。儘管我們致力於提供準確和有價值的學習資源，AI生成的內容可能存在不完整、不準確、或非預期的結果。任何AI
            生成的回應或內容，使用者應自行核實其準確性，並謹慎使用。
          </p>

          <h2>免責聲明：</h2>
          <ul>
            <li>
              <strong>內容準確性：</strong>任何生成式 AI
              所提供的內容僅供參考，本網站無法保證其完全正確或為最新資訊，使用者須自行予以核實和調整。使用者對於信賴或使用生成之內容所產生的任何形式之糾紛、損失或損害，本網站及其運營方不承擔任何法律責任。
            </li>
            <li>
              <strong>專業建議替代：</strong>生成式
              AI的回應或內容不應被視為專業建議、法律意見或權威性答案，使用者應根據實際情況尋求獨立之法律意見或其他專業意見。
            </li>
            <li>
              <strong>技術限制：</strong>生成式AI
              具有其技術上的侷限，生成的回應或內容可能不完全符合使用者需求，並可能會在某些情境下產生不恰當或不妥適的結果。本網站及其運營方無法保證生成內容之完整性或適用性。
            </li>
          </ul>

          <h2>智慧財產權聲明：</h2>
          <ul>
            <li>
              <strong>AI 生成之內容：</strong>本網站所使用的生成式 AI
              是基於公共訓練數據及開放技術開發，AI
              生成的內容不受特定來源或專有數據的控制。由於生成內容的自動性，本網站及其運營方無法對其內容進行完整之第三方智慧財產權檢查或控管，亦無法保證使用者能夠對AI
              生成的內容主張著作權等智慧財產權利。
            </li>
            <li>
              <strong>第三方資料的潛在引用：</strong>AI
              生成的內容有時可能無意識地模仿或引用已存在的資料或作品。若發現有侵犯第三方著作權等智慧財產權的情況，請立即通知本網站，本網站將迅速採取行動，包括移除相關內容。
            </li>
          </ul>

          <h2>使用者責任：</h2>
          <ul>
            <li>
              使用者在本網站上創建或傳輸之任何內容，應確保不違反任何法律法規，不侵害他人的權利。
            </li>
            <li>
              使用者有責任確保其使用從本網站獲得的 AI
              生成內容均符合著作權等智慧財產權之相關法律，並在使用該內容（如轉載、分享、或商業應用）時，取得必要的授權或許可，使用者違反相關法令或不當使用AI
              生成內容所產生之任何損失或損害，本網站及其運營方不承擔任何法律責任。
            </li>
          </ul>

          <p>
            本網站保留隨時修改本免責聲明及智慧財產權聲明之權利，使用者應定期查閱免責聲明，以瞭解相關政策及任何變更。
          </p>

          <p class="reference">
            引用來源：<br />
            <a
              href="https://support.microsoft.com/zh-tw/topic/%E4%BB%80%E9%BA%BC%E6%98%AF%E8%B2%A0%E8%B2%AC%E4%BB%BB%E7%9A%84-ai-33fc14be-15ea-4c2c-903b-aa493f5b8d92"
              target="_blank"
              rel="noopener noreferrer"
              >MICROSOFT 負責任AI 說明</a
            ><br />
            <a
              href="https://openai.com/policies/terms-of-use/"
              target="_blank"
              rel="noopener noreferrer"
              >OPENAI使用條款</a
            >
          </p>
        </div>

        <div class="" v-else>
          <h1>Disclaimer and Copyright Notice for AI Generated Content</h1>

          <p>
            Portions of this website's content and functionalities are
            automatically generated by Generative Artificial Intelligence
            (Generative AI) technology. Although we strive to provide accurate
            and valuable learning resources, AI-generated content may contain
            incomplete, inaccurate, or unexpected results. Users should verify
            the accuracy of any AI-generated responses or content and use them
            with caution.
          </p>

          <h2>Disclaimer:</h2>
          <ul>
            <li>
              <strong>Content Accuracy:</strong> Any content provided by
              Generative AI is for reference only. This website cannot guarantee
              its complete accuracy or that it represents the most up-to-date
              information. Users must verify and adjust as necessary. This
              website and its operators assume no legal responsibility for any
              disputes, losses, or damages arising from reliance on or use of
              the generated content.
            </li>
            <li>
              <strong>Substitute for Professional Advice:</strong> Responses or
              content from Generative AI should not be considered professional
              advice, legal opinions, or authoritative answers. Users should
              seek independent legal counsel or other professional advice based
              on their specific circumstances.
            </li>
            <li>
              <strong>Technical Limitations:</strong> Generative AI has
              technical limitations; generated responses or content may not
              fully meet user needs and may produce inappropriate or unsuitable
              results in certain contexts. This website and its operators cannot
              guarantee the completeness or applicability of the generated
              content.
            </li>
          </ul>

          <h2>Intellectual Property Rights Notice:</h2>
          <ul>
            <li>
              <strong>AI-Generated Content:</strong> The Generative AI used by
              this website is developed based on public training data and open
              technologies. AI-generated content is not controlled by specific
              sources or proprietary data. Due to the automated nature of the
              generated content, this website and its operators cannot conduct
              comprehensive third-party intellectual property rights checks or
              controls, nor can they guarantee that users can claim copyright or
              other intellectual property rights over AI-generated content.
            </li>
            <li>
              <strong>Potential References to Third-Party Materials:</strong>
              AI-generated content may sometimes unconsciously mimic or
              reference existing data or works. If you discover any infringement
              of third-party copyrights or other intellectual property rights,
              please notify this website immediately, and we will promptly take
              action, including removing the relevant content.
            </li>
          </ul>

          <h2>User Responsibilities:</h2>
          <ul>
            <li>
              Users should ensure that any content they create or transmit on
              this website does not violate any laws or regulations and does not
              infringe upon the rights of others.
            </li>
            <li>
              Users are responsible for ensuring that their use of AI-generated
              content obtained from this website complies with relevant
              copyright and intellectual property laws, and for obtaining
              necessary authorizations or permissions when using such content
              (such as for republishing, sharing, or commercial applications).
              This website and its operators assume no legal responsibility for
              any losses or damages resulting from users' violations of relevant
              laws or improper use of AI-generated content.
            </li>
          </ul>

          <p>
            This website reserves the right to modify this disclaimer and
            intellectual property rights notice at any time. Users should
            regularly review the disclaimer to understand relevant policies and
            any changes.
          </p>

          <p class="reference">
            References:<br />
            <a
              href="https://support.microsoft.com/zh-tw/topic/%E4%BB%80%E9%BA%BC%E6%98%AF%E8%B2%A0%E8%B2%AC%E4%BB%BB%E7%9A%84-ai-33fc14be-15ea-4c2c-903b-aa493f5b8d92"
              target="_blank"
              rel="noopener noreferrer"
              >MICROSOFT Responsible AI Guidelines</a
            ><br />
            <a
              href="https://openai.com/policies/terms-of-use/"
              target="_blank"
              rel="noopener noreferrer"
              >OPENAI Terms of Use</a
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
import i18n from "@/locales";
const { locale, t } = useI18n({
  inheritLocale: true,
});
const currentLang = locale.value;
import { useRouter } from "vue-router";

const router = useRouter();

const goBack = () => {
  router.go(-1);
};
</script>

<style lang="scss" scoped>
.disclaimer-page {
  padding: 2rem 0;
  background-color: #f8f9fa;
  min-height: 100vh;
}

.disclaimer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  padding-bottom: 1rem;
  margin-bottom: 2rem;

  h1 {
    margin-bottom: 0;
    font-size: 2rem;
    color: #333;
  }

  .back-button {
    display: flex;
    align-items: center;
    gap: 0.5rem;

    i {
      font-size: 1.2rem;
    }
  }
}

.disclaimer-content {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 2rem;

  h1 {
    font-size: 1.75rem;
    color: #333;
    margin-bottom: 1.5rem;
  }

  h2 {
    font-size: 1.35rem;
    color: #444;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }

  p {
    line-height: 1.7;
    margin-bottom: 1.5rem;
    color: #333;
  }

  ul {
    padding-left: 1.5rem;
    margin-bottom: 1.5rem;

    li {
      margin-bottom: 0.75rem;
      line-height: 1.7;
      color: #333;

      strong {
        color: #000;
      }
    }
  }

  .reference {
    font-style: italic;
    font-size: 0.9rem;
    color: #666;
    margin-top: 2.5rem;
    border-top: 1px solid #eee;
    padding-top: 1.5rem;

    a {
      color: #0066cc;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }

      &:visited {
        color: #551a8b;
      }
    }
  }

  .en-content {
    margin-top: 3rem;
  }
}

@media (max-width: 768px) {
  .disclaimer-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;

    h1 {
      font-size: 1.5rem;
    }
  }

  .disclaimer-content {
    padding: 1.5rem;

    h1 {
      font-size: 1.5rem;
    }

    h2 {
      font-size: 1.25rem;
    }
  }
}
.custom-padding {
  padding: 0rem 1rem;
}
@media (max-width: 992px) {
  .custom-padding {
    padding: 2.8rem 1rem;
  }
}
</style>
